import service from '../allservices.jsx'
import { getClientId, getClientSecret,buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';

export function secretQues(actionCallback) {
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let gid = getClientId();
    let traceId = getClientId();
    fetch(plink + service.secret_ques, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'clientId': gid,
            'clientSecret': getClientSecret(gid, ""),
            'X-Trace-Id': traceId,
            'X-KlickEx-Client':buildClientHeader(),
        })
    })
        .then(response => {
            if (response.status === 200 || response.status === 201) {
                response.json().then(json => actionCallback(json, "success"))
            } else {
                response.json().then(json => actionCallback(json, "Error"))

            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/secret_ques.jsx